export default {
  title: 'Găsește ceva care îți place!',
  description: 'Comenzile tale vor fi afișate aici.',
  buttons: {
    order_now: 'Comandă acum',
  },
};
